module.exports = __webpack_public_path__ + "img/4-5.c9c03988.svg";